import React from 'react';

const Footer = ({ settings }) => {
    const footerText = settings ? (settings.footerText || `© ${new Date().getFullYear()} Hulk Cabeleireiro. Todos os direitos reservados.`) : '';

    return (
        <footer className="bg-neutral-950 py-8">
            <div className="container mx-auto px-6 text-center text-gray-500 text-sm">
                <p>{footerText}</p>
                <p className="mt-2">Desenvolvido por: <a href="https://uniccode.com.br" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary transition-colors">Unic Code</a>.</p>
            </div>
        </footer>
    );
};

export default Footer;
